import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpParams } from '@angular/common/http';
import { take, exhaustMap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Device credentials are attached only to our household/check-in API routes.
    if (req.url.startsWith(environment.apiHost + '/') && /\/(?:Member\/GetLimitedMembersByUserId|Checkin\/AddCheckIn(?:ByService|ByGroup|ByVenue)?)(?:[?]|$)/i.test(req.url)) {
      const device = this.authService.checkinDevices.read();
      if (device) req = req.clone({setHeaders:{'X-Checkin-Device':device.token}});
    }
    return this.authService.user.pipe(
      take(1),
      exhaustMap((user) => {
        if (!user) {
          return next.handle(req);
        }
        const modifiedReq: HttpRequest<any> = req.clone({
          setHeaders: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        return next.handle(modifiedReq);
      })
    );
  }
}
